import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import router from './router'

const werktijdApi = axios.create({
  baseURL: process.env.VUE_APP_APIHOST + '/api/1/',
  validateStatus: function (status) {
    return status < 500; // Reject only if the status code is greater than or equal to 500
  }
})
werktijdApi.interceptors.response.use(r => {
  if (r.status === 403) {
    router.push('/aanmelden')
  }
  return r
})
werktijdApi.interceptors.request.use(function (config) {
  const token = localStorage.getItem('authToken') || store.getters.authToken
  if (token) config.headers.Authorization = token
  return config
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: function() { return {
    api: werktijdApi,
    snackbarVisible: false,
    snackbarMsg: "",
    dialogVisible: false,
    dialogText: "",
    confirmVisible: false,
    confirmText: "",
    confirmResolver: undefined,
    authToken: ""
  }},
  mutations: {
    setSnackbarMsg (state, msg) {
      state.snackbarMsg = msg
      state.snackbarVisible = true
    },
    showDialog (state, msg) {
      state.dialogText = msg
      state.dialogVisible = true
    },
    hideDialog (state) {
      state.dialogVisible = false
      state.dialogText = ""
    },
    showConfirm (state, msg) {
      state.confirmText = msg
      state.confirmVisible = true
    },
    hideConfirm (state) {
      state.confirmVisible = false
      state.confirmText = ""
    },
    setConfirmResolver (state, r) {
      state.confirmResolver = r
    },
    setAuthToken (state, token) {
      state.authToken = token
    }
  },
  actions: {
    async askConfirm({ commit }, msg) {
        commit('showConfirm', msg)
        return new Promise((resolve) => { commit('setConfirmResolver', resolve) })
    }
  },
  getters: {
    authToken: state => {
      return state.authToken
    }
  }
})

export default store